import { styled } from "styled-components";

export const MyPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 1000px;
`;
